module.exports = __webpack_public_path__ + "static/media/house-outline.027d4484.svg";